import { NgModule } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { DeNativeDateAdapter } from './shared/de-native-date-adapter';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DE_DATE_FORMATS } from './shared/de-date-formats';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { provideStorage, getStorage, connectStorageEmulator } from '@angular/fire/storage';
import { provideDatabase, getDatabase, connectDatabaseEmulator } from '@angular/fire/database';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PurchasesComponent } from './purchases/purchases.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InjectComponentDirective } from './inject-component.directive';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { RedirectComponent } from './redirect/redirect.component';
import { CreateContentTypeDialogComponent } from './content-type/create-content-type-dialog/create-content-type-dialog.component';
import { ContentEditDialogComponent } from './content-edit-dialog/content-edit-dialog.component';
import { EditValueContentDialogComponent } from './edit-value-content-dialog/edit-value-content-dialog.component';
import { ContextIdSelectorComponent } from './context-id-selector/context-id-selector.component';
import { FilterContentsPipe} from './shared/filter.pipe';
import { FilterTridyPipe } from './shared/filter-tridy.pipe';
import { FilterExperiencesPipe } from './shared/filterExperiences.pipe';
import { FilterProductsPipe } from './shared/filter-product.pipe';
import { FilterTasksPipe } from './shared/filter-tasks.pipe';
import { FilterFinishedPipe } from './shared/filter-finished.pipe';
import { DeleteConfirmationDialogComponent } from './delete-confirmation-dialog/delete-confirmation-dialog.component';
import { TranslatePipe, provideTranslateService } from '@ngx-translate/core';
import { DatePipe, CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
// import { USE_EMULATOR as USE_DATABASE_EMULATOR } from '@angular/fire/compat/database';
// import { USE_EMULATOR as USE_FIRESTORE_EMULATOR, SETTINGS as FIRESTORE_SETTINGS } from '@angular/fire/compat/firestore';
// import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
// import { REGION, USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions';
import { InfoMesageDialogComponent } from './info-mesage-dialog/info-mesage-dialog.component';
import { FormResultsDetailsDialogComponent } from './form-results-details/form-results-details.component';
import { CanDeactivateGuard } from './can-deactivate/can-deactivate.guard';
import { CancelChangesDialogComponent } from './cancel-changes-dialog/cancel-changes-dialog.component';
import { DuplicateTaskTemplateDialogComponent } from './duplicate-task-template-dialog/duplicate-task-template-dialog.component';
// MATERIAL MODULES
import { MatBadgeModule } from '@angular/material/badge';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs'
import { MatDividerModule } from '@angular/material/divider'
import { MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTreeModule} from '@angular/material/tree';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from  '@angular/material/slide-toggle';
// WYSWIG QUILL
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import QuillMarkdown from 'quilljs-markdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmChangesDialogComponent } from './confirm-changes-dialog/confirm-changes-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

Quill.register('modules/markdown', QuillMarkdown);

// AG GRID
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, IntegratedChartsModule, LicenseManager } from "ag-grid-enterprise";
import { AgCharts } from "ag-charts-angular";

import { AgChartsEnterpriseModule } from "ag-charts-enterprise";


// AG GRID
ModuleRegistry.registerModules([
  AllCommunityModule,
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule)
]);

import { FreePublisherInfoDialogComponent } from './free-publisher-info-dialog/free-publisher-info-dialog.component';
import { connectFirestoreEmulator, initializeFirestore, provideFirestore } from '@angular/fire/firestore';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { RouterModule } from '@angular/router';
import { SystemMonitoringComponent } from './system-monitoring/system-monitoring.component';
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-093055}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Narravero_GmbH}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{nv-publisher}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{nv-publisher}_need_to_be_licensed___{nv-publisher}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{15_August_2026}____[v3]_[0102]_MTc4Njc0ODQwMDAwMA==19a2a7afe9fbc5c276c894e15c4a474c");

const isCypress = typeof window !== 'undefined' && (window as any).Cypress;
const host = isCypress ? '127.0.0.1' : 'localhost';

registerLocaleData(localeDe);

@NgModule({
    declarations: [
        AppComponent,
        SystemMonitoringComponent,
        PurchasesComponent,

        InjectComponentDirective,

        RedirectComponent,

        CreateContentTypeDialogComponent,
        // ContentComponent,
        ContentEditDialogComponent,
        EditValueContentDialogComponent,

        ContextIdSelectorComponent,
        
        FilterContentsPipe,
        FilterTridyPipe,
        FilterExperiencesPipe,
        FilterProductsPipe,
        FilterTasksPipe,
        FilterFinishedPipe,
        DeleteConfirmationDialogComponent,

        FormResultsDetailsDialogComponent,


        CancelChangesDialogComponent,

        DuplicateTaskTemplateDialogComponent,


        ConfirmChangesDialogComponent,

        FreePublisherInfoDialogComponent,
        
    ],
    exports: [
        InjectComponentDirective,
        MatButtonModule
    ],
    bootstrap: [AppComponent],

    imports: [
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        MatSidenavModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        CommonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatDividerModule,
        MatOptionModule,
        MatSelectModule,
        MatTabsModule,
        MatListModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        MatCardModule,
        MatGridListModule,
        MatChipsModule,
        ClipboardModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTreeModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatProgressBarModule,
        NgxMatSelectSearchModule,
        AgGridAngular,
        AgCharts,
        RouterModule,
        TranslatePipe,
        QuillModule.forRoot({
            modules: {
                markdown: {}
            }
        }),
        MatBadgeModule,
        NgbModule],
    providers: [
        // CDK 21 renders overlays (dialogs, menus) in the browser top layer by default, which hides
        // body-level z-index overlays such as the ngx-colors picker behind them
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        provideFirebaseApp(() => {
            const app = initializeApp(environment.firebase);

            if (!environment.production) {
                (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
                    window.localStorage.getItem('FIREBASE_APPCHECK_DEBUG_TOKEN') || true;
            }

            return app;
        }),
        provideAppCheck(() => {
            const appCheck = initializeAppCheck(getApp(), {
                provider: new ReCaptchaEnterpriseProvider(environment.appCheck.recaptchaSiteKey),
                isTokenAutoRefreshEnabled: true,
            });
            (self as any).__appCheck = appCheck;

            return appCheck;
        }),
        //auth
        provideAuth(() => {
            const auth = getAuth()
            if (environment.useEmulators) {
                connectAuthEmulator(auth, `http://${host}:9099`, {
                    disableWarnings: true,
                });
                console.log('Using Auth emulator', host);
            }
            return auth
        }),
        //functions
        provideFunctions(() => {
            const functions = getFunctions(getApp(), 'europe-west1');
            if (environment.useEmulators) {
                connectFunctionsEmulator(functions, host, 5001);
                console.log("Using emulator for functions");
            }
            return functions;
        }),
        //storage
        provideStorage(() => {
            const storage = getStorage();
            if (environment.useEmulators) {
                connectStorageEmulator(storage, host, 9199);
                console.log('Using Storage emulator');
            }
            return storage;
        }),
        provideFirestore(() => {
            // const firestore = getFirestore();
            const firestore = initializeFirestore(getApp(), { ignoreUndefinedProperties: true })
            if (environment.useEmulators) {
                connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
                console.log('Using Firestore emulator');
            }
            return firestore;
        }),
        //https
        provideHttpClient(withInterceptorsFromDi()),
        //guard
        CanDeactivateGuard,
        //locale
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        //material date config
        { provide: DateAdapter, useClass: DeNativeDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: DE_DATE_FORMATS },
        //common
        DatePipe,
        // { provide: REGION, useValue: 'europe-west1' },
        // { provide: FIRESTORE_SETTINGS, useValue: { ignoreUndefinedProperties: true } },
        // { provide: USE_AUTH_EMULATOR, useValue: environment.useEmulators ? ['http://' + host + ':9099'] : undefined },
        // { provide: USE_DATABASE_EMULATOR, useValue: environment.useEmulators ? [host, 9000] : undefined },
        provideDatabase(() => {
            const database = getDatabase();
            if (environment.useEmulators) {
              connectDatabaseEmulator(database, host, 9000);
              console.log('Using Database emulator');
            }
            return database;
        }),

        provideTranslateService({
            loader: provideTranslateHttpLoader({
              prefix: '/assets/i18n/',
              suffix: '.json',
              failOnError: true
            }),
            fallbackLang: 'en',
            lang: 'en'
        })
        // { provide: USE_FIRESTORE_EMULATOR, useValue: environment.useEmulators ? [host, 8080] : undefined },
    ] })
export class AppModule { }
